import { MEALME_API_URL } from '@/constants/config'
import { StoreDetail } from '@/lib/food/foodModel'
import call from '@/utils/api/call'

export async function getStoreDetailById({
  signal,
  store_id,
  pickup,
  include_quote,
  quote_preference,
  include_customizations,
  user_latitude,
  user_longitude,
  user_street_num,
  user_street_name,
  user_city,
  user_state,
  user_zipcode,
  user_country,
  available,
  include_fees,
  include_menu,
}: {
  signal?: AbortSignal
  store_id: string
  pickup: boolean
  include_quote: boolean
  quote_preference: string
  include_customizations: boolean
  user_latitude: number
  user_longitude: number
  user_street_num: string
  user_street_name: string
  user_city: string
  user_state: string
  user_zipcode: string
  user_country: string
  available: boolean
  include_fees: boolean
  include_menu: boolean
}) {
  return call
    .get(`${MEALME_API_URL}/details/inventory/v4`, {
      params: {
        store_id,
        pickup,
        include_quote,
        quote_preference,
        include_customizations,
        user_latitude,
        user_longitude,
        user_street_num,
        user_street_name,
        user_city,
        user_state,
        user_zipcode,
        user_country,
        available,
        include_fees,
        include_menu,
        use_new_db: true,
      },
      signal,
    })
    .then(res => {
      return StoreDetail(res.data)
    })
}
